'use client';

import { useState } from 'react';

/**
 * Nyckel som byter värde varje gång användaren byter organisation — men inte
 * när organisationen fylls i för första gången (den ligger i localStorage och
 * återställs först efter första renderingen).
 *
 * Nyckeln sätts på dashboardens innehåll så att sidan monteras om och hämtar
 * sin data för den nya föreningen. Det ersätter en `window.location.reload()`:
 * menyn, headern och sidobaren står kvar, bara innehållet laddas om.
 *
 * Värdet räknas upp under renderingen (inte i en effekt) så att barnen aldrig
 * hinner rendera en gång med gammal nyckel och ny organisation — annars hade
 * varje byte gett en extra, bortkastad hämtning.
 */
export function useOrganisationsbytesNyckel(orgId?: string): number {
  const [läge, setLäge] = useState<{ orgId?: string; nyckel: number }>({ orgId, nyckel: 0 });

  if (läge.orgId !== orgId) {
    setLäge((föregående) => ({
      orgId,
      // Första gången organisationen får ett värde är det ingen växling.
      nyckel: föregående.orgId === undefined ? föregående.nyckel : föregående.nyckel + 1,
    }));
  }

  return läge.nyckel;
}
